<div class="card mt-36">
  <div class="card-header">
    <div class="d-flex align-items-baseline">
      <h4 class="m-r-5">{{ "location.remuneration.title" | translate }}</h4>
    </div>
    <hr style="width: 87%; margin-bottom: 0; position: absolute" />
  </div>
  <div class="card-body">
    <div *ngIf="forbidden" class="d-flex justify-content-center m-t-20">
      {{ "response.error.FORBIDDEN_RESPONSE" | translate }}
    </div>
    <div *ngIf="loadingPayment && !forbidden">
      <ng-container style="float: right" class="flex">
        <div class="loader-box">
          <div class="loader-34"></div>
        </div>
        <h6 class="col align-self-center f-w-600" style="text-align: center">
          {{ "fetching" | translate }}
        </h6>
      </ng-container>
    </div>
    <div class="row" *ngIf="!loadingPayment">
      <div class="col-12 col-xl-12">
        <div class="grid-column">
          <div class="media align-items-baseline">
            <h5 class="m-r-10">
              {{ "franchise.remuneration.totalFranchised" | translate }}
            </h5>
            {{ paymentDetails.totalFranchised }}
          </div>

          <div class="media align-items-baseline">
            <h5 class="m-r-10">
              {{ "franchise.remuneration.totalViews" | translate }}
            </h5>
            {{ paymentDetails.totalViews }}
          </div>

          <div class="media align-items-baseline">
            <h5 class="m-r-10">
              {{ "franchise.remuneration.totalFinishedCampaigns" | translate }}
            </h5>
            {{ paymentDetails.totalFinishedCampaigns }}
          </div>

          <div class="media align-items-baseline">
            <h5 class="m-r-10">
              {{ "franchise.remuneration.nextPayment" | translate }}
            </h5>
            {{ paymentDetails.nextPayment.toFixed(3) }}
          </div>
        </div>
        <img
          class="ant-remuneration"
          src="assets/identity/ant-remuneration.svg"
          alt="ant"
        />
      </div>
    </div>
  </div>
</div>

<div class="card">
  <div class="card-header pb-0">
    <div class="media-space-between">
      <h4>{{ "franchise.remuneration.title" | translate }}</h4>
      <div class="media-body">
        <form class="d-inline-flex" [formGroup]="formFilter">
          <app-date-range-picker
            [form]="formFilter"
            inputFormControlName="date"
          ></app-date-range-picker>
          <div class="m-r-10">
            <app-search-field
              [form]="formFilter"
              [filterOptions]="filterPayment"
              [placeholder]="'placeholder.searchByCompanyName' | translate"
              inputFormControlName="companyName"
              (emitSelectedOptions)="saveOptionFilter($event)"
            ></app-search-field>
          </div>
          <div style="margin-left: 10px">
            <app-refresh-button
              [state]="fetchingHistoryState"
              [date]="cachedAt"
              (buttonClick)="filterData(true)"
            ></app-refresh-button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="card-body">
    <div class="table-responsive data-table">
      <form>
        <table class="table table-border-vertical">
          <thead>
            <tr>
              <ng-container *ngFor="let column of columns">
                <th>
                  {{ column.label | translate }}
                </th>
              </ng-container>
            </tr>
          </thead>
          <tbody *ngIf="!loading">
            <ng-container
              *ngFor="let franchised of remunerationDetails; let i = index"
            >
              <ng-container
                *ngFor="
                  let advertisingCampaign of franchised.advertisingCampaigns
                "
              >
                <tr
                  [ngStyle]="
                    i % 2
                      ? { '--bs-table-accent-bg': '#ffffff' }
                      : { '--bs-table-accent-bg': '#f3f3f3' }
                  "
                >
                  <td
                    class="td-border-bottom-color"
                    *ngIf="
                      advertisingCampaign === franchised.advertisingCampaigns[0]
                    "
                    [attr.rowspan]="franchised.advertisingCampaigns.length"
                  >
                    {{ franchised.companyName }}
                  </td>

                  <td
                    class="td-border-bottom-color"
                    *ngIf="
                      advertisingCampaign === franchised.advertisingCampaigns[0]
                    "
                    [attr.rowspan]="franchised.advertisingCampaigns.length"
                  >
                    {{ franchised.price }}
                  </td>

                  <td
                    class="td-border-bottom-color"
                    *ngIf="
                      advertisingCampaign === franchised.advertisingCampaigns[0]
                    "
                    [attr.rowspan]="franchised.advertisingCampaigns.length"
                  >
                    <span
                      [ngClass]="
                        'badge ' +
                        badgeService.getBadgeByLocationPartnerPaymentFrequency(
                          franchised.paymentFrequency || paymentFrequency.NONE
                        )
                      "
                    >
                      {{
                        franchised.paymentFrequency
                          ? ("enumMapping.paymentFrequency." +
                              franchised.paymentFrequency | translate)
                          : ("UNDEFINED" | translate)
                      }}
                    </span>
                  </td>

                  <td class="td-border-bottom-color">
                    {{ advertisingCampaign.title }}
                    <i
                      class="icofont icofont-check-circled color-success"
                      *ngIf="advertisingCampaign.isPaid; else notPaid"
                    ></i>
                    <ng-template #notPaid>
                      <i
                        class="icofont icofont-close-circled"
                        style="color: red"
                      ></i>
                    </ng-template>
                  </td>

                  <td class="td-border-bottom-color">
                    {{ advertisingCampaign.startDate | localizedDate }}
                  </td>

                  <td class="td-border-bottom-color">
                    {{ advertisingCampaign.endDate | localizedDate }}
                  </td>

                  <td class="td-border-bottom-color">
                    {{ advertisingCampaign.impressions }}
                  </td>

                  <td class="td-border-bottom-color">
                    <span
                      [ngClass]="
                        'badge ' +
                        badgeService.getBadgeForLPRemuneration(
                          advertisingCampaign.remunerationStatus
                        )
                      "
                    >
                      {{
                        remunerationEnumMapping[
                          advertisingCampaign.remunerationStatus
                        ] | translate
                      }}
                    </span>
                  </td>
                  <td class="td-border-bottom-color">
                    <span
                      [ngClass]="
                        'badge ' +
                        badgeService.getBadgeForAdvertisingCampaingStatus(
                          advertisingCampaign.status
                        )
                      "
                    >
                      {{
                        "enumMapping.campaigns.status." +
                          advertisingCampaign.status | translate
                      }}
                    </span>
                  </td>

                  <td class="td-border-bottom-color">
                    {{ advertisingCampaign.revenueAmount.toFixed(3) }} TND
                    <app-info-tooltip-component
                      *ngIf="
                        showTooltip(advertisingCampaign.remunerationStatus)
                      "
                      [infoTooltip]="
                        getRevenueTooltip(
                          advertisingCampaign.paidImpressions,
                          advertisingCampaign.paidPeriodStart,
                          advertisingCampaign.paidPeriodEnd
                        )
                      "
                      [placement]="'left'"
                    ></app-info-tooltip-component>
                  </td>
                </tr>
              </ng-container>
            </ng-container>
          </tbody>
        </table>
        <div *ngIf="forbidden" class="d-flex justify-content-center m-t-20">
          {{ "response.error.FORBIDDEN_RESPONSE" | translate }}
        </div>
        <div *ngIf="loading && !forbidden">
          <ng-container style="float: right" class="flex">
            <div class="loader-box">
              <div class="loader-34"></div>
            </div>
            <h6
              class="col align-self-center f-w-600"
              style="text-align: center"
            >
              {{ "fetching" | translate }}
            </h6>
          </ng-container>
        </div>
        <div
          *ngIf="remunerationDetails.length === 0 && !loading && !forbidden"
          class="d-flex justify-content-center m-t-20"
        >
          {{ "noData" | translate }}
        </div>
      </form>
    </div>
    <app-pager
      id="pager"
      [count]="count"
      [pageSize]="pageSize"
      [pageNumber]="pageNumber"
      (emitChangePage)="changePage($event)"
      (emitChangePageSize)="itemsPerPageChange($event)"
      for="announcersTable"
    ></app-pager>
  </div>
</div>
